import type { User } from '@core/models/user.model';
import type { AuthFacade } from '@/auth/facades/auth.facade';
import type { UserProfileFacade } from '@/user/facades/user-profile.facade';

/**
 * Executes the asynchronous tasks common to every way a session can be established:
 * dispatches the authenticated user to the store and loads the user profile.
 *
 * @param {AuthFacade} authFacade - The authentication facade instance for managing application state and side effects.
 * @param {User} userData - The authenticated user's data to be dispatched to the store.
 * @param {UserProfileFacade} userProfileFacade - Facade responsible for fetching and managing the user's profile data.
 * @returns {Promise<void>} A promise that resolves after all tasks have been executed.
 */
export const performCommonTasks = async (
  authFacade: AuthFacade,
  userData: User,
  userProfileFacade: UserProfileFacade,
): Promise<void> => {
  await authFacade.setUser(userData);
  await userProfileFacade.loadUserProfile();
};
